import type { RoadmapCompanyConfig } from '@/types/roadmap.types';
import { tetrasoftConfig } from './tetrasoft/config';
import { fincaMarketIncConfig } from './finca-market-inc/config';

const companies: Record<string, RoadmapCompanyConfig> = {
  [tetrasoftConfig.id]: tetrasoftConfig,
  [fincaMarketIncConfig.id]: fincaMarketIncConfig,
};

export function getCompany(id: string): RoadmapCompanyConfig | undefined {
  return companies[id];
}

export function getCompanyIds(): string[] {
  return Object.keys(companies);
}
